import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, effect, signal, OnInit, Output, ViewChild, input, Injector, Inject, TemplateRef, } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Observable, Subscription, forkJoin, from, map, of, switchMap, take, tap } from 'rxjs';
import { NomenclatorFacade } from 'src/app/abstraction/nomenclator.facade';
import { LocationPOI } from 'src/app/shared/models/maps/locationPOI';
import { MarkerGoogleMaps } from 'src/app/shared/models/maps/markerGoogleMaps';
import { Specialty } from 'src/app/shared/models/specialty';
import { MapsService } from 'src/app/shared/services/maps.service';
import { Provider } from 'src/app/shared/models/provider';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { EntitiesFacade, PROVIDERS_STATUS_BACKGROUND_COLORS, PROVIDERS_STATUS_COLORS } from 'src/app/abstraction/entities.facade';
import { ProvisionsFacade } from 'src/app/abstraction/provisions.facade';
import { AgreementsBySpecialtyQPS } from 'src/app/core/services/provisions.service';
import { Patient } from 'src/app/shared/models/patient';
import { MapsFacade } from 'src/app/abstraction/maps.facade';
import { TypeMapMarker } from 'src/app/core/enums/typeMapMarker';
import { Agreement } from 'src/app/shared/models/agreement';
import moment from 'moment';
import { filterFromdateList } from 'src/app/shared/models/filter';
import { Provision } from 'src/app/shared/models/provision';
import { ProvidersBySpecialtyQPS, ProvidersQPS } from 'src/app/core/services/providers.service';
import { Practice } from 'src/app/shared/models/practice';
import { GeneralService } from 'src/app/core/services/general.service';
import { onCheckMarker } from '../../components/markers-list/markers-list.component';
import { locateMarker } from '../../components/map/map.component';
import { PROVIDER_STATUS, PROVIDER_STATUS_TAGS } from 'src/app/core/enums/providerStatus';
import { ProviderByStatusAndLocation } from 'src/app/core/enums/ProviderByStatusAndLocation';
import { PATIENT_STATUS } from 'src/app/core/enums/patientStatus';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { Router } from '@angular/router';
import { ProvidersManagementComponent } from 'src/app/modules/data-management/pages/providers-management/providers-management/providers-management.component';
import { AlertService } from 'src/app/core/services/alert.service';
import { IconMapMarker } from 'src/app/core/enums/iconMapMarker';



@Component({
    selector: 'app-specialties-providers-pois',
    templateUrl: './specialties-providers-pois.component.html',
    styleUrl: './specialties-providers-pois.component.scss',
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ display: 'none' })),
            state('expanded', style({ display: 'visible' })),
            transition(
                'expanded <=> collapsed',
                animate('230ms cubic-bezier(0.4, 0.0, 0.2, 1)')
            ),
            transition(
                'expanded <=> void',
                animate('230ms cubic-bezier(0.4, 0.0, 0.2, 1)')
            ),
        ]),
    ],

})
export class SpecialtiesProvidersPoisComponent implements OnInit {
    public readonly SPECIALTIES = 'specialties';
    public readonly SPECIALTIES_ID = 'id';
    public readonly SPECIALTIES_SEARCHING = 'specialtiesSearching';
    public readonly FROMDATE = 'fromDate';
    public readonly INCLUDE_PROVIDERS = 'includeProviders';
    public readonly INCLUDE_ACTIVE_PATIENTS = 'includeActivePatients';
    public readonly INCLUDE_INACTIVE_PATIENTS = 'includeInactivePatients';
    public readonly MEDICAL_LICENSES = 'medicalLicenses';
    public readonly MEDICAL_LICENSE_VALUE = 'value';
    public readonly MEDICAL_LICENSE_VALIDITY = 'validity';
    public readonly MEDICAL_LICENSE_TYPE = 'type';
    public readonly SELECT_PROVIDERS = 'selectProviders';
    public readonly INCLUDE_PROVIDER_PATIENTS_ADDRESS = 'includeProviderPatientsAddress';
    public readonly INCLUDE_PROVIDER_PATIENTS_ZONE = 'includeProviderPatientsZone';
    private _center: MarkerGoogleMaps;
    private _addressSelected: MarkerGoogleMaps;

    @ViewChild('mapDiv') mapDiv: ElementRef;
    @Input() isExpanded: boolean = false;
    @Input() inputMarkers: MarkerGoogleMaps[];
    specialtyId = input<number>();
    mapRefsWidth:number=0
    mapRefPt:number=0
    screenCalling = input<string>();
    patient = input<Patient>();
    provision = input<Provision>();
    specialty = input<Specialty>();
    _dialogRef
    dspInjector!: Injector;
    @ViewChild('providerDSPHost', { static: true }) providerDSPHost!: TemplateRef<any>;
    @Output('onChangeExpand') onChangeExpandEvent = new EventEmitter<boolean>();

    readonly ProviderByStatusAndLocation = ProviderByStatusAndLocation;
    patientsByProvider: Patient[] = [];
    isLoadingGetAgreementsBySpecialtyId$: Observable<boolean>;
    _markers: Subscription;
    resetFlags = {
        active: true,
        inactive: false,
        possible: true,
        cancelled: true,
        _timeStamp: Date.now()
    };
    tabSelectedIndex = 0;
    providersForm: FormGroup;
    localMarkers: MarkerGoogleMaps[];
    IconMapMarkers = IconMapMarker;
    poi: LocationPOI;
    index: number = 0;
    agreementsBySpecialty: Agreement[];
    patients: Patient[];
    practice: Practice;
    specialtyName: string;
    patientsActive: Patient[];
    patientsInactive: Patient[];
    actualProviderSpecialties: string[] = [null];
    specialtiesOnSelect: [Specialty[]];
    providerMarkerSelected: MarkerGoogleMaps;
    providerSelected: boolean = true;
    specialtySelected: number = null;
    lastSpecialctySelected: number | null = null;
    dataVisible: boolean = true;
    filterVisible: boolean = true;
    flow: string = null;
    checkPatientsActive: boolean = false;
    sideNavExpanded: boolean = false;
    checkPatientsInactive: boolean = false;
    refresh: boolean = false;
    onGetPatientsFocus:{focus:boolean,timeStamp:Date}=null;
    cd: ChangeDetectorRef;
    enableFilters: boolean = false;
    resetList: boolean = false;
    mapWidth: number;
    loadingProviderSelectedFilter: boolean = false;
   TypeProviderMarker = 'PROVIDER';
   TypePatientMarker = 'PATIENT';
   providerMarkerSelectedAddressVisibility:{markerId: number, value:boolean}=null;
   providerMarkerSelectedZonesVisibility:{markerId: number, value:boolean}=null;
    providerPatients: MarkerGoogleMaps[];
    mapHeight: number;
    cardHeight: number;
    providersListVisible: boolean = true;
    showAllProvidersList: boolean = true;
    markerSelectedFromProviderList: locateMarker;
    actualCenter: MarkerGoogleMaps;
    providersManagementCmp = ProvidersManagementComponent;
    fromDateFilters: filterFromdateList[] = [
        {
            id: 1,
            description: 'Último mes',
            value: moment().subtract(1, 'months').startOf('month'),
        },
        {
            id: 2,
            description: 'Ûltimos 2 meses',
            value: moment().subtract(2, 'months').startOf('month'),
        },
        {
            id: 3,
            description: 'Ûltimos 3 meses',
            value: moment().subtract(3, 'months').startOf('month'),
        },
        {
            id: 6,
            description: 'Ûltimos 6 meses',
            value: moment().subtract(6, 'months').startOf('month'),
        },
        {
            id: 9,
            description: 'Ûltimos 9 meses',
            value: moment().subtract(9, 'months').startOf('month'),
        },
        {
            id: 12,
            description: 'Ûltimos 12 meses',
            value: moment().subtract(12, 'months').startOf('month'),
        },
    ];
    providerStatusTags: Record<PROVIDER_STATUS, string> = {
        [PROVIDER_STATUS.ACTIVE]: PROVIDER_STATUS_TAGS.ACTIVE,
        [PROVIDER_STATUS.INACTIVE]: PROVIDER_STATUS_TAGS.INACTIVE,
        [PROVIDER_STATUS.POSSIBLE]: PROVIDER_STATUS_TAGS.POSSIBLE,
        [PROVIDER_STATUS.CANCELLED]: PROVIDER_STATUS_TAGS.CANCELLED,
    };
    PROVIDERS_STATUS_COLORS = PROVIDERS_STATUS_COLORS;
    PROVIDERS_STATUS_BACKGROUND_COLORS = PROVIDERS_STATUS_BACKGROUND_COLORS;
    fromDateSelected: Date = this.fromDateFilters[5].value.toDate();
    btn_active = signal(false);
    btn_inactive = signal(false);
    btn_possible = signal(false);
    btn_cancelled = signal(false);
    allProvidersFilters = ProviderByStatusAndLocation
    providersStatusFiltered: PROVIDER_STATUS[] = [];
    providersLocationsFiltered: ProviderByStatusAndLocation[] = [];
    providersLocationsFilteredPois: TypeMapMarker[] = [];
    statusSignals: [() => boolean, PROVIDER_STATUS][] = [
        [() => this.btn_active(), PROVIDER_STATUS.ACTIVE],
        [() => this.btn_inactive(), PROVIDER_STATUS.INACTIVE],
        [() => this.btn_possible(), PROVIDER_STATUS.POSSIBLE],
        [() => this.btn_cancelled(), PROVIDER_STATUS.CANCELLED],
    ];
    prevStatusValues = new Map<PROVIDER_STATUS, boolean>(this.statusSignals.map(([_, status]) => [status, false]));

    get center() {
        return this._center;
    }

    set center(value) {
        this._center = value;
    }

    get addressSelected() {
        return this._addressSelected;
    }

    set addressSelected(value) {
        this._addressSelected = value;
        this.center = value;
    }

    getProviderPatientsZone() {
        return this.INCLUDE_PROVIDER_PATIENTS_ZONE
    }

    getProviderPatientsAddress() {
        return this.INCLUDE_PROVIDER_PATIENTS_ADDRESS
    }


    constructor(
        private generalService: GeneralService,
        public entitiesFacade: EntitiesFacade,
        public mapsService: MapsService,
        private mapsFacade: MapsFacade,
        private provisionsFacade: ProvisionsFacade,
        private formBuilder: FormBuilder,
        private nomenclatorFacade: NomenclatorFacade,
        private alertService: AlertService,
        public dialog: MatDialog,
        private router: Router,
        private injector: Injector,
        @Inject(DOCUMENT) private document: Document,
    ) {
        effect(() => { //read component open flow (case o sidebar)
            this.flow = this.screenCalling();
            //----PROVISIONS-DETAIL FLOW----//
            if (!!this.screenCalling()) {
                if (!!this.specialty()) {
                    this.specialtySelected = this.specialty()?.id
                }
                this.practice = this.provision()?.practice;
                this.specialtyName = this.specialty()?.name;
                const patientMarker = this.mapsService.castPatientFromCaseToMarkerGoogleMaps(this.patient(), TypeMapMarker.CASE);
                this.mapsFacade.mergeMarkers([patientMarker]);
            }
        });

        effect(() => { //reactive status filters actions
            for (const [getSignal, status] of this.statusSignals) {
                const current = getSignal();    //boolean
                const previous = this.prevStatusValues.get(status)!;
                const typeMap = this.getMarkerTypeFromStatus(status)
                if (current === previous) {       //no change
                    continue;
                }
                this.prevStatusValues.set(status, current);
                this.providerStatusFilteredManager(status, current);  //global status filter consulter
                if (current) {  //add
                    this.mergeProvidersStatusToMap(status);
                } else {          //subtract
                    this.mapsFacade.deleteMarkersByTypes(this.getMarkerTypeFromStatus(status));
                    this.mapsFacade.deleteClusters(typeMap);
                }
            }
        });
    }

    ngOnInit(): void {
        this.generalService.sideNavState$.subscribe(expanded => {
            this.sideNavExpanded = expanded;
            this.mapRefsWidth = !this.sideNavExpanded ? this.mapWidth - 100 : this.mapWidth - 240;
            this.mapRefPt = !this.sideNavExpanded ? 100 : 240;
        })
        this.generalService.sendMessage("Buscar Prestadores");
        this.providersForm = this.createProvidersForm();
        this.isLoadingGetAgreementsBySpecialtyId$ = this.provisionsFacade.isLoadingGetAgreementsBySpecialtyId$();

        this._markers = this.mapsFacade.getMarkers$().subscribe((markers) => { //save local markers
            if (!!markers) {
                this.localMarkers = [...markers];
            }
        });
        this.providersForm.get('includeProviderPatientsAddress').valueChanges.subscribe(value => {
            this.providerMarkerSelectedAddressVisibility={markerId:this.providerMarkerSelected?.id,value:value}
            this.loadingProviderSelectedFilterSpinner();
        });
        this.providersForm.get('includeProviderPatientsZone').valueChanges.subscribe(value => {
            this.providerMarkerSelectedZonesVisibility={markerId:this.providerMarkerSelected?.id,value:value}
            this.loadingProviderSelectedFilterSpinner();
        });
    }

    ngAfterViewInit(): void {
        this.mapWidth = this.mapDiv.nativeElement.offsetWidth;
        this.mapHeight = this.mapDiv.nativeElement.offsetHeight;
        this.mapRefsWidth = !this.sideNavExpanded ? this.mapWidth - 100 : this.mapWidth - 300;
    }

    providerStatusFilteredManager(filter: PROVIDER_STATUS, value: boolean) {   //on filter map providers by status
        if (value) {
            this.providersStatusFiltered.push(filter);
        } else {
            this.providersStatusFiltered = this.providersStatusFiltered.filter(f => f !== filter);
        }
    }

    intersectStatuses(arr1: ProviderByStatusAndLocation[], arr2: ProviderByStatusAndLocation[]): ProviderByStatusAndLocation[] {     //match ProviderByStatusAndLocation filters
        return Array.from(
            new Set(
                arr1.flat().filter(status => arr2.flat().includes(status))
            )
        );
    }

    providersLocationsFilteredManager(locations: ProviderByStatusAndLocation[], value: boolean) {
        if (value) {
            const newItems = locations.filter(loc => !this.providersLocationsFiltered.includes(loc));
            this.providersLocationsFiltered = [...this.providersLocationsFiltered, ...newItems];
        } else {
            this.providersLocationsFiltered = this.providersLocationsFiltered.filter(
                f => !locations.includes(f)
            );
        }
        this.providersLocationsFilteredPois = this.mapsService.providersStatusLocationsToMarkers(this.providersLocationsFiltered);
        this.updateLocatiosVibility(locations, value);
    }

    updateLocatiosVibility(locations, value) { //update visibility from providers filtered on map state
        const actualStatusPois: ProviderByStatusAndLocation[] = [];
        const typeMarkers = this.mapsService.providersStatusLocationsToMarkers(locations);
        this.providersStatusFiltered.forEach((p: PROVIDER_STATUS) => { // accum all component status in statusAndLocations types
            const matchedProviders = this.getProviderByStatusMatches(p);
            actualStatusPois.push(...matchedProviders);
        });
        let filtered = this.intersectStatuses(actualStatusPois, this.providersLocationsFiltered); // match by status [] and locations [] filtered
        const markers = this.mapsService.providersStatusLocationsToMarkers(filtered); // convert matched to markers
        markers.push(TypeMapMarker.CLUSTER)
        this.mapsFacade.setProvidersMarkersVisibility(markers); //set visible true this markers
        // value ? this.mapsFacade.addClusters() : this.mapsFacade.deleteClusters(typeMarkers) //add o delete clusters
    }

    mergeProvidersStatusToMap(status: PROVIDER_STATUS): void { //merge providers status filtered to map state
        const [state1, state2] = this.getProviderByStatusMatches(status); //1 status = 2 states
        const providers1$ = this.entitiesFacade.getProvidersByStatusAndLocation$(state1).pipe(take(1));
        const providers2$ = this.entitiesFacade.getProvidersByStatusAndLocation$(state2).pipe(take(1));

        providers1$.pipe(switchMap(providers1 => {
            if (!providers1?.length) {
                return from(this.loadProvidersBySpecialty(status));
            }
            return forkJoin([of(providers1), providers2$]).pipe(
                map(([p1, p2]) => [...p1, ...p2])
            );
        }),
            tap(allProviders =>{
                this.updateMapMarkers(allProviders)
            } )
        )
            .subscribe({ error: err => console.error('Error al mergear providers:', err) });
    }


    updateMapMarkers(providers: Provider[] = []): void {
        if(providers == null || providers == undefined){return;} //update map state => merge between  status and locations, cast and clusterization
        const actualStatusPois = this.providersStatusFiltered.flatMap(p => this.getProviderByStatusMatches(p)); //[provider status] to [provider status and location]
        // const filterMatches = this.intersectStatuses(actualStatusPois, this.providersLocationsFiltered); //match by locations and status filters
        const filtersToTypeMapMarker = this.mapsService.providersStatusLocationsToMarkers(actualStatusPois);//cast matched to typeMapMarker
        const filtered = providers?.filter(p => filtersToTypeMapMarker.includes(p.poiType));// filter by typeMapMarker
        const pois = this.mapsService.castProvidersToMarkerGoogleMaps(filtered); //cast filtered
        let locations = this.mapsService.providersStatusLocationsToMarkers(this.providersLocationsFiltered);
        pois.forEach(p => {
            if (locations.includes(p.type)) {
                p.visible = true;
            } else {
                p.visible = false;
            }
        });
        this.mapsFacade.mergeMarkers(pois)
        this.mapsFacade.addClusters();
    }

    getProviderByStatusMatches(status: PROVIDER_STATUS): ProviderByStatusAndLocation[] { //match PROVIDER_STATUS with ProviderByStatusAndLocation
        return Object.values(ProviderByStatusAndLocation).filter(
            (value): value is ProviderByStatusAndLocation => {
                if (status === PROVIDER_STATUS.INACTIVE) {
                    return value === ProviderByStatusAndLocation.INACTIVE_ADDRESS ||
                        value === ProviderByStatusAndLocation.INACTIVE_ZONE;
                }
                return value.startsWith(status + '_');
            }
        );
    }

    initialBtnsActions() { //default actions on status buttons
        this.btn_active.set(true);
        this.btn_possible.set(true);
        this.btn_cancelled.set(true);
        let allProviders = Object.values(ProviderByStatusAndLocation);
        this.providersLocationsFilteredManager(allProviders, true);
    }

    restoreValues() { //retore values on select specialty
        this.resetList=true
        setTimeout(() => {
            this.resetList=false
        }, 100);
        this.btn_active.set(false);
        this.btn_possible.set(false);
        this.btn_cancelled.set(false);
        this.btn_inactive.set(false);
        this.providersStatusFiltered = [];
        this.providersLocationsFiltered = [];
        this.prevStatusValues.clear();
        for (const [_, status] of this.statusSignals) {
            this.prevStatusValues.set(status, false);
        }

    }



    onPressMarkerLocation(event: onCheckMarker) { //on press marker location from map
        this.markerSelectedFromProviderList = null;
        let marker: MarkerGoogleMaps;
        let markerWithChange: locateMarker;
        if (!!event?.clusterId) {
            marker = this.localMarkers.find(m => m.id === event.clusterId);
            markerWithChange = {
                marker: marker,
                timeStamp: new Date(),
                clusterMember: event.id
            }
        } else {
            marker = this.localMarkers.find(m => m.id === event.id && m.type === event.type);
            markerWithChange = {
                marker: marker,
                timeStamp: new Date()
            }
        }
        if (!!marker) {
            this.markerSelectedFromProviderList = markerWithChange;
        } else {
            console.warn(`No se encontró un marcador con id ${event.id} y tipo ${event.type}`);
        }
    }

    onTabChanged(e) { //on change screen tab\
        this.tabSelectedIndex = e.index;
    }

    onEnableFilters() { //set enable filters
        this.enableFilters = true;
    }

    getSpecialtiesByName = (value: string) => this.nomenclatorFacade.loadSpecialties({ name_like: value }); //get specialties by name


    calculateNameSpecialty(element) {
        return element ? element.name : null;
    }

    calculateIdSpecialty(element) {
        return element ? element.id : null;
    }

    setDataVisible() { //expand or collapse information tab on the filters
        this.dataVisible = !this.dataVisible;
    }

    createProvidersForm() {
        return this.formBuilder.group({
            arrangement: new FormControl({ disabled: false }),
            [this.SPECIALTIES_ID]: [''],
            [this.SPECIALTIES_SEARCHING]: [''],
            [this.SELECT_PROVIDERS]: [true],
            [this.INCLUDE_PROVIDER_PATIENTS_ADDRESS]: [true],
            [this.INCLUDE_PROVIDER_PATIENTS_ZONE]: [true],
        });
    }

    removeDuplicatedEntities = (entitieList) => { //remove duplicated entities from list
        const result = entitieList.reduce((acc, current) => {
            if (!acc.some((item) => item.id === current.id)) {
                acc.push(current);
            }
            return acc;
        }, []);
        return result;
    };

    getPatientsActiveBySpecialty() { //filter local  active patients
        const activePatientsBySpecialty = [];
        const activePatientsToPois = [];

        // get active agreements by specialty
        const activeAgreements = this.agreementsBySpecialty
            .flatMap(agreements => agreements.casee)
            .filter(element => element.active === true);

        activeAgreements.forEach(a => {
            a.patient.caseId = a.id;
        });

        // get active patients by specialty
        activePatientsBySpecialty.push(
            activeAgreements.flatMap(agreement => agreement.patient)
        );

        const activePatientsToReduce = activePatientsBySpecialty.flat();
        //delete duplicates
        const uniqueActivePatients = this.removeDuplicatedEntities(
            activePatientsToReduce
        );
        activePatientsToPois.push(...uniqueActivePatients);
        const activePatientsToMarker = [];
        activePatientsToPois.forEach((patient: Patient) => {
            const castActivePatientsToPois = this.mapsService.castPatientToMarkerGoogleMaps(patient, TypeMapMarker.PATIENT_ACTIVE);
            activePatientsToMarker.push(castActivePatientsToPois);
        });
        this.patientsActive = activePatientsToMarker;
        this.mapsFacade.mergeMarkers(activePatientsToMarker);
        this.mapsFacade.addClusters();
    }

    getPatientsInactiveBySpecialty() {  //filter local  inactive patients
        const inactivePatientsBySpecialty = [];
        let inactivePatientsToPois = [];

        const inactiveAgreements = this.agreementsBySpecialty
            .flatMap(agreements => agreements.casee)
            .filter(element => element.active === false);

        inactiveAgreements.forEach(a => {
            a.patient.caseId = a.id;
        });

        //Inactive patients by specialty
        inactivePatientsBySpecialty.push(
            inactiveAgreements.flatMap(agreement => agreement.patient)
        );

        inactivePatientsToPois = inactivePatientsBySpecialty.flat();

        //Delete repeated patients
        const uniqueActivePatients = this.removeDuplicatedEntities(
            inactivePatientsToPois
        );
        inactivePatientsToPois.push(...uniqueActivePatients);
        const inactivePatientsToMarker = [];
        inactivePatientsToPois.forEach((patient: Patient) => {
            const castActivePatientsToPois = this.mapsService.castPatientToMarkerGoogleMaps(patient, TypeMapMarker.PATIENT_INACTIVE);
            inactivePatientsToMarker.push(castActivePatientsToPois);
        });
        this.patientsInactive = inactivePatientsToMarker;
        this.mapsFacade.mergeMarkers(inactivePatientsToMarker);
        this.mapsFacade.addClusters();
    }

    getPatientsByProviderAndSpecialty() { //filter local  active patients
        const uniquePatients = this.removeDuplicatedEntities(this.patientsByProvider);
        const activeProviderPatientsMarkers = [];
        const inactiveProviderPatientsMarkers = [];
        uniquePatients.forEach((patient: Patient) => {
            if (patient.active) {
                activeProviderPatientsMarkers.push(this.mapsService.castPatientToMarkerGoogleMaps(patient, TypeMapMarker.PATIENT_ACTIVE))
            } else {
                inactiveProviderPatientsMarkers.push(this.mapsService.castPatientToMarkerGoogleMaps(patient, TypeMapMarker.PATIENT_INACTIVE))
            }
        });

        let markers = [...activeProviderPatientsMarkers, ...inactiveProviderPatientsMarkers]
        this.providerPatients = markers;
        this.mapsFacade.mergeMarkers(markers);
        this.mapsFacade.addClusters();
    }

    getAgreementsBySpecialty() { //get agreements by specialty id
        this.agreementsBySpecialty = [];
        this.patientsActive = [];
        this.patientsInactive = [];
        let qps: AgreementsBySpecialtyQPS = {
            specialtyId: this.specialtySelected,
            ...(this.fromDateSelected && { fromDate: this.fromDateSelected }),
        };
        this.provisionsFacade
            .loadAgreementBySpecialtyId(qps)
            .subscribe((agreements) => {
                this.agreementsBySpecialty = agreements;
                if (agreements) {
                    this.checkPatientsActive ? this.getPatientsActiveBySpecialty() : null
                    this.checkPatientsInactive ? this.getPatientsInactiveBySpecialty() : null
                }
            });
    }

    getAgreementsByProviderId() {
        let id: number;
        id = this.providerMarkerSelected?.id;

        let qps: AgreementsBySpecialtyQPS = {
            specialtyId: this.specialtySelected,
            ...(this.fromDateSelected && { fromDate: this.fromDateSelected }),
            providerId: id
        };
        this.provisionsFacade
            .loadAgreementBySpecialtyId(qps)
            .subscribe((agreements) => {
                this.patientsByProvider = [];
                agreements.forEach(a => {
                    let patient: Patient = a.casee.patient;
                    patient.caseId = a.casee.id;
                    patient.active = a.casee.active;
                    this.patientsByProvider.push(patient)
                })
                this.getPatientsByProviderAndSpecialty()
            })

    }

    onSelectSpecialty(specialty) { //default actions on select specialty
        if (!!specialty?.id) {
            this.cleanStates();
            this.specialtyName = specialty?.name;
            this.specialtySelected = specialty?.id;
            this.restoreValues();
            this.getAgreementsBySpecialty();
            this.onEnableFilters();
            this.setShowAllProvidersList();
            this.initialBtnsActions();
            this.resetFlags = {
                active: true,
                inactive: false,
                possible: true,
                cancelled: true,
                _timeStamp: Date.now()
            };
        }
    }

    onProviderMarkerSelected(event: {marker:MarkerGoogleMaps, patientsFocus?:boolean}) {
        this.dataVisible = true;
        this.onGetPatientsFocus=null
        this.tabSelectedIndex = 1;
        this.providerMarkerSelected = this.deleteOtherSpecialtiesInThisMarker(event.marker);
        this.getAgreementsByProviderId();
        if(event.patientsFocus){
            this.dataVisible=false;
            this.onGetPatientsFocus={
                focus:true,
                timeStamp:new Date(),
            }
        }
    }

    cleanStates() { //clean all states
        this.mapsFacade.deleteAllMarkers();
        this.entitiesFacade.clearProvidersByStatusAndLocation();
        this.mapsFacade.deleteAllClusterMembers();
    }

    deleteOtherSpecialtiesInThisMarker(marker: MarkerGoogleMaps): MarkerGoogleMaps {
        let providerSpecialtyData;
        marker.specialties.forEach(s => {
            if (s.id === this.specialtySelected) {
                providerSpecialtyData = s;
                return;
            }
        })
        delete marker.specialties;
        marker.specialties = [providerSpecialtyData];
        return marker;
    }

    loadProvidersBySpecialty = async (status: PROVIDER_STATUS): Promise<Provider[]> => { // call service with qps
        const qps: ProvidersBySpecialtyQPS = { active: status === PROVIDER_STATUS.ACTIVE ? true : false, specialtyId: this.specialtySelected, status: status };
        try {
            const providers = await this.entitiesFacade.loadProvidersByStatusAndLocations(qps); //traemos los prestadores casteados por status and location
            if (providers.length > 0) {
                return providers ?? [];
            }
        } catch (err) {
            console.error('Error cargando providers:', err);
        }
    };

    onChangeProviderStatusFilter(value: boolean, name: string): void { // set signal by status
        const signalRef = (this as any)[name];
        signalRef.set(value);
    }

    getMarkerTypeFromStatus(status: PROVIDER_STATUS): TypeMapMarker[] { //convert PROVIDER_STATUS to TypeMapMarker
        switch (status) {
            case PROVIDER_STATUS.ACTIVE:
                return [TypeMapMarker.PROVIDER_ACTIVE_ADDRESS, TypeMapMarker.PROVIDER_ACTIVE_ZONE]
                break;
            case PROVIDER_STATUS.CANCELLED:
                return [TypeMapMarker.PROVIDER_INACTIVE_CANCELLED_ADDRESS, TypeMapMarker.PROVIDER_INACTIVE_CANCELLED_ZONE]
                break;
            case PROVIDER_STATUS.INACTIVE:
                return [TypeMapMarker.PROVIDER_INACTIVE_ADDRESS, TypeMapMarker.PROVIDER_INACTIVE_ZONE]
                break;
            case PROVIDER_STATUS.POSSIBLE:
                return [TypeMapMarker.PROVIDER_INACTIVE_POSSIBLE_ADDRESS, TypeMapMarker.PROVIDER_INACTIVE_POSSIBLE_ZONE]
                break;
            default:
                break;
        }
    }

    onChangePatientActiveFilter(event) { //listen to active patients filter
        event == false ?
            [
                this.mapsFacade.deleteMarkersByType(TypeMapMarker.PATIENT_ACTIVE),
                this.checkPatientsActive = false
            ]
            :
            [
                this.getPatientsActiveBySpecialty(),
                this.checkPatientsActive = true
            ]
    }

    onChangePatientInactiveFilter(event) { //listen to inactive patients filter
        event == false ?
            [
                this.mapsFacade.deleteMarkersByType(TypeMapMarker.PATIENT_INACTIVE),
                this.checkPatientsInactive = true
            ]
            :
            [
                this.getPatientsInactiveBySpecialty(),
                this.checkPatientsInactive = false
            ]
    }

    // onChangeExpand of Providers List
    setProvidersListVisible() {
        this.providersListVisible = !this.providersListVisible
    }

    setShowAllProvidersList() { //set pois to visible true in map state
        let value = this.providersForm.get(this.SELECT_PROVIDERS).value;
        this.mapsFacade.setVisibleAllMarkers(value)
        this.showAllProvidersList = value
    }

    getMapCenter(event: MarkerGoogleMaps) {
        this.actualCenter = event
    }

    onChangeFromDateFilter(event) {
        this.mapsFacade.deleteMarkersByTypes([TypeMapMarker.PATIENT_INACTIVE, TypeMapMarker.PATIENT_ACTIVE])
        this.agreementsBySpecialty = null;
        this.fromDateSelected = event;
        this.getAgreementsBySpecialty();
    }

    onChangePatientByStatusFilter(status: PATIENT_STATUS, value: boolean) { //listen to patients by status filter
        switch (status) {
            case PATIENT_STATUS.ACTIVE:
                if (value) {
                    this.getPatientsActiveBySpecialty()
                } else {
                    this.mapsFacade.deleteMarkersByTypes([TypeMapMarker.PATIENT_ACTIVE])
                }
                this.checkPatientsActive = value
                break;
            case PATIENT_STATUS.INACTIVE:
                if (value) {
                    this.getPatientsInactiveBySpecialty()
                } else {
                    this.mapsFacade.deleteMarkersByTypes([TypeMapMarker.PATIENT_INACTIVE])
                }
                this.checkPatientsInactive = value
                break;
            default:
                console.warn('Status not managed');
        }
    }

    setPatientsFiltersVisible(event: boolean) {
        event ? this.getAllPatients() : this.mapsFacade.deleteMarkersByTypes([TypeMapMarker.PATIENT_ACTIVE, TypeMapMarker.PATIENT_INACTIVE]);
    }

    getAllPatients() {
        this.checkPatientsActive = true;
        this.checkPatientsInactive = true;
        this.getAgreementsBySpecialty();
    }

    openReadOnly(marker: MarkerGoogleMaps): void {
        try{
        let providerId = marker.oldId;
        let qps:ProvidersQPS = {
            id:providerId,
            active:marker.active
        }
        this.entitiesFacade.loadProviders(qps)
        this.dspInjector = Injector.create({
          providers: [
            { provide: MAT_DIALOG_DATA, useValue: { mode: 'DSP', providerId } }
          ],
          parent: this.injector
        });

        this._dialogRef = this.dialog.open(DialogComponent, {
          disableClose: true,
          panelClass: 'dm-dsp-dialog',
          minWidth: '80%',
          maxHeight: '90%',
          data: {
            template: this.providerDSPHost,
            title: `${marker.name}`,
          }
        });
      }catch(error){
        console.error('Error opening read-only DSP:', error);
        }
    }


    goToProviderSchedule(providerMarker:MarkerGoogleMaps): void {
        const providerId = providerMarker?.oldId ?? '';
        const urlTree = this.router.createUrlTree(['/app', 'gestion', 'agenda', providerId]);
        const relativeUrl = this.router.serializeUrl(urlTree);

        const base = this.document.baseURI || this.document.location.origin + '/';
        const absoluteUrl = new URL(relativeUrl, base).toString();

        window.open(absoluteUrl, '_blank', 'noopener');
    }

    onGetSisa(licenseValue?: string) {
        this.copyToClipboard(licenseValue.toString());
        const base = 'https://sisa.msal.gov.ar/sisa/#sisa';
        const url = base;

        const w = 900, h = 700;
        const y = window.top?.outerHeight
            ? window.top.outerHeight / 2 + window.top.screenY - h / 2
            : 100;
        const x = window.top?.outerWidth
            ? window.top.outerWidth / 2 + window.top.screenX - w / 2
            : 100;

        window.open(
            url,
            'sisa_popup',
            `popup=yes,toolbar=no,location=no,status=no,menubar=no,` +
            `scrollbars=yes,resizable=yes,width=${w},height=${h},top=${y},left=${x}`
        );
    }

    copyToClipboard(value) { //copy text from medical license
        navigator.clipboard.writeText(value).then(() => {
                this.alertService.openInfo('Texto copiado al portapapeles');
            })
            .catch(err => {
                console.error('Error al copiar:', err);
            });
    }
    loadingProviderSelectedFilterSpinner() {
        this.loadingProviderSelectedFilter = true;
        setTimeout(() => {
            this.loadingProviderSelectedFilter = false;
        }, 500);
    }

    closeProviderMarkerTab(){
        this.providerMarkerSelected = null;
    }

    showProviderCard(){
        let locateMarker: locateMarker={
            marker: {
                id: this.providerMarkerSelected.id,
                type: this.providerMarkerSelected.type,
                clusterId: this.providerMarkerSelected.clusterId ?? undefined,
                visible: !!this.providerMarkerSelected.visible,
            },
            timeStamp: new Date(),
        }
        if(!!locateMarker.marker.clusterId){
            locateMarker.marker.id = locateMarker.marker.clusterId
            locateMarker.marker.type = TypeMapMarker.CLUSTER
        }
        this.markerSelectedFromProviderList = locateMarker
    }


    ngOnDestroy() {
        this.mapsFacade.setMarkers(null);
        !!this._markers ? this._markers.unsubscribe() : null;
        this.center = null;
        this.localMarkers = null;
        this.screenCalling = null;
    }
}
